module.exports = __webpack_public_path__ + "static/img/8.fbac714.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/5/sp/8.png
// module id = Ca/Y
// module chunks = 0